<template>
  <div class="add-domain" :class="{ 'edit-mode': isEditMode}">
    <transition name="slide-fade">
      <div class="add-domain-wrap"
           v-show="!showTrackingCode">
        <div class="add-header">
          <ui-button :iconName="'icon--arrow-left-black'"
                     @click="toDashboard">&nbsp;&nbsp;&nbsp;{{ $t('registration.goBackList') }}</ui-button>
        </div>
        <div class="add-body">
          <div class="left-side">
            <div class="step step-1"
                 :class="{ active: step === 1, animating: animating }">
              <h3 class="step-title" @click="goStep(1)" :class="{complete: stepCompleted.step1}">
                <i :class="{ complete: step !== 1 && stepCompleted.step1 }">1</i>
                <span>
                  {{ $t('registration.domainToAnalyze') }}
                  <span class="show-on-active">{{ $t('registration.settingsToAnalyze') }}</span>
                  <span class="hide-on-active">*.{{ model.domain | domain }}</span>
                </span>
              </h3>
              <div class="step-content">
                <div class="form">
                  <ui-input-text :type="'text'"
                                 :id="'domain'"
                                 :name="'domain'"
                                 :placeholder="$t('registration.urlToAnalyze.placeholder')"
                                 :modelValue="model.viewRealUrl"
                                 :modelError="modelError.domain"
                                 :byteLimit="950"
                                 @input="setDomain"
                                 @onFocus="modelError.domain = ''">
                    {{ $t('registration.urlToAnalyze.title') }}
                  </ui-input-text>
                  <div class="validation" :class="{ pass: stepCompleted.step1, fail: !!modelError.domain }">
                    <i class="icon icon--validation-pass"></i>
                    <i class="icon icon--validation-alert"></i>
                  </div>
                </div>
                <div class="note">
                  <h5>{{ $t('common.note') }}</h5>
                  <p class="description">
                    {{ $t('registration.urlToAnalyze.description') }}
                  </p>
                  <div class="example">
                    https://www.<mark>beusble.net</mark>/ko/features-reportheatmap
                  </div>
                </div>
              </div>
              <div class="step-footer">
                <div class="button-wrap" :class="{ show: !stepCompleted.step1 }">
                  <ui-button :primary="true"
                             :size="'xlarge'"
                             :iconName="'icon--clipboard'"
                             :loading="validating"
                             :disabled="!allowValidation"
                             @click="onValidateUrl">{{ $t('common.validation') }}</ui-button>
                </div>
                <div class="button-wrap" :class="{ show: stepCompleted.step1 }">
                  <ui-button :primary="true"
                             :size="'xlarge'"
                             :iconName="'icon--check-white'"
                             :disabled="!stepCompleted.step1"
                             @click="goStep(2)">{{ $t('common.next') }}</ui-button>
                </div>
              </div>
            </div>
            <div class="step step-2"
                 :class="{ active: step === 2, animating: animating }">
              <h3 class="step-title" @click="goStep(2)" :class="{complete: stepCompleted.step1}">
                <i :class="{ complete: step !== 2 && stepCompleted.step2 }">2</i>
                <span>{{ $t('registration.details') }}</span>
              </h3>
              <div class="report-custom-tap">
                <div class="tap main" :class="{ on: detailTarget === 'report' }" @click="onTapSelect('report');setCarouselIndex(1)">{{ $t('registration.detailTarget.label.report') }}</div>
                <div class="tap" :class="{ on: detailTarget === 'ad' }" v-if="isExact" @click="onTapSelect('ad');setCarouselIndex(4)">{{ $t('registration.detailTarget.label.ad') }}</div>
                <div class="tap" :class="{ on: detailTarget === 'custom' }" v-else @click="onTapSelect('custom');setCarouselIndex(4)">{{ $t('registration.detailTarget.label.custom') }}</div>
              </div>
              <div class="step-content" v-if="detailTarget === 'report'" :class="{'timezoneEdit' : isTimezoneChange}">
                <div class="form" :class="{'timezoneEdit' : isTimezoneChange}">
                  <div class="option">
                    <p class="label">
                      {{ $t('registration.mapName.title') }}
                    </p>
                    <div class="content">
                      <ui-input-text :type="'text'"
                                     :placeholder="$t('registration.mapName.placeholder')"
                                     :modelValue="model.domainName"
                                     :modelError="modelError.domainName"
                                     :byteLimit="950"
                                     @input="setDomainName"
                                     @onFocus="setCarouselIndex(1)"
                                     @onBlur="setCarouselIndex(2)">

                      </ui-input-text>
                    </div>
                  </div>
                  <div class="option" :class="{'timezoneEdit' : isTimezoneChange}" @click="setCarouselIndex(2)">
                    <p class="label" :class="{top: isTimezoneChange}">
                      {{ $t('timezone.dashboard.info') }}
                    </p>
                    <div class="content" :class="{top: isTimezoneChange}">
                      <template v-if="!isTimezoneChange">
                        <span class="value">{{model.timezoneName}}</span>
                      </template>
                      <template v-else >
                        <timezone-selectbox
                            :value="model.timezoneName"
                            :width="'100%'"
                            @change="onChangeTimezone"
                            :placeholder="$t('timezone.dashboard.selectPlaceholder')">
                        </timezone-selectbox>
                        <div class="timezone-desc">
                          <ul>
                            <li><p v-html="$t('timezone.dashboard.desc1')"></p></li>
                            <li><p class="highlight" v-html="$t('timezone.dashboard.desc2')"></p></li>
                          </ul>
                        </div>

                        <div class="timezone-agree">
                          <ui-checkbox v-model="isAgree" :disabled="!model.timezoneName">
                          <span class="terms-agree">
                            {{ $t('timezone.dashboard.check') }}
                          </span>
                          </ui-checkbox>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="option" :class="{ warning: pvWarning, less: internalPvLimit === 0, 'timezoneEdit' : isTimezoneChange}">
                    <p class="label">
                      <span>
                        {{ $t('registration.pvLimit.title') }}
                      </span>
                      <span class="tip" :class="{'timezoneEdit' : isTimezoneChange}" v-if="!isExact">
                        <ui-icon-tooltip :iconSize="'outline-white'"
                                         arrowBottom
                                         arrowCenter>
                          <span v-html="$t('registration.pvLimit.tip')"></span>
                        </ui-icon-tooltip>
                      </span>
                    </p>
                    <div class="content">
                      <span class="pv-edit" v-if="isEditMode">
                        <ui-input-text :type="'text'"
                                      :modelValue="originalPvLimit < 0 ? $t('common.noLimit') : thousand(originalPvLimit)"
                                      :disabled="true" />
                        <i v-if="!isExact" class="icon icon--arrow-body-right-gray"></i>
                      </span>
                      <div class="pv-edit-box" v-if="!isExact">
                        <ui-selectbox :value="internalPvLimit"
                                      :items="pvLimitOptionList"
                                      :width="145"
                                      :class="'pv-range'"
                                      :slideUp="true"
                                      @click="setCarouselIndex(3)"
                                      @input="onPVLimitChange" />
                        <div class="custom-input" :class="{ edit: isEditMode }" v-if="internalPvLimit === 0">
                          <div class="input">
                            <ui-input-text :type="'number'"
                                          :placeholder="''"
                                          :id="'customPvLimit'"
                                          :name="'customPvLimit'"
                                          :min="1"
                                          :modelValue="customPvLimit"
                                          @onFocus="setCarouselIndex(3)"
                                          @input="checkCustomPvLimit" />
                          </div>
                          <div class="unit">
                            {{ $t('common.unit.pv') }}
                          </div>
                        </div>
                        <div v-if="pvWarning"
                            class="pv-warning"
                            v-html="$t('registration.pvLimit.warning')">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="step-content" v-if="detailTarget === 'custom'" :class="[detailTarget]">
                <div class="form" :class="[detailTarget]">
                  <div class="option custom">
                    <p class="label custom">
                      {{ $t('customTag.label') }}
                    </p>
                    <div class="content">
                      <div class="custom-use-check-radios" ref="customRadio">
                        <div class="item customRadio">
                          <ui-radio :value="customUse"
                                    :disabled="!isCustomUser"
                                    @input="onCustomUseChange(true)">
                            {{ $t('registration.detailTarget.use') }}
                          </ui-radio>
                          <span class="desc" v-if="customUse" >
                            {{ $t('registration.detailTarget.customUseDesc1') }}
                          </span>
                          <span class="desc next" v-if="customUse && isEditMode" >
                            {{ $t('registration.detailTarget.customUseDesc2') }}
                          </span>

                        </div>
                        <div class="item customRadio">
                          <ui-radio :value="!customUse"
                                    @input="onCustomUseChange(false)">
                            {{ $t('registration.detailTarget.notUse') }}
                          </ui-radio>
                          <span class="desc" v-if="!customUse">
                          {{ $t('registration.detailTarget.customNotUseDesc') }}
                        </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="option custom input" :class="[$i18n.locale, {'edit': isEditMode}]" v-if="customUse">
                    <p class="label custom">
                    </p>
                    <div class="content customInput">
                      <div class="item">
                        <ui-input-text :type="'text'"
                                       :placeholder="$t('registration.detailTarget.customPlaceholder')"
                                       :modelValue="model.beuCustomId"
                                       :modelError="modelError.beuCustomId"
                                       :byteLimit="950"
                                       @input="setBeuCustomId"
                                       @onFocus="modelError.beuCustomId = ''"
                        >
                          {{ $t('registration.detailTarget.tagName') }}
                        </ui-input-text>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div class="step-content" v-if="detailTarget === 'ad'" :class="[detailTarget]">
                <div class="campaign-header">
                  <div class="campaign-header-title">
                    <p>{{ $t('registration.detailTarget.ad.title') }}</p>
                    <i
                      class="icon icon--info-outline-gray"
                      v-btf-tooltip="{ contents: $t('registration.detailTarget.ad.descriptionOn'), size: 200, offsetY: -5, textAlign: 'left', wordBreak: 'normal' }"
                    ></i>
                  </div>
                  <ba-switch :value="isAdToggleOn" :default="false" @change="isAdToggleOn = !isAdToggleOn" />
                </div>
                <div
                  v-if="isAdToggleOn"
                  class="campaign-content-wrap"
                  :class="{'show-top-gradient': adHasTopGradient, 'show-bottom-gradient': adHasBottomGradient}"
                >
                  <div ref="adContent" class="campaign-content" @scroll="updateAdContentGradient">
                    <p class="campaign-content-title">{{ $t('registration.detailTarget.ad.autoRemoved') }}</p>
                    <div class="campaign-content-tabs" role="tablist" aria-label="자동 제거 파라미터 카테고리">
                      <button
                        v-for="category in adParameterCategories"
                        :key="category.value"
                        type="button"
                        class="campaign-content-tab"
                        :class="{ active: adSelectedCategory === category.value }"
                        @click="adSelectedCategory = category.value"
                      >
                        <span class="label">{{ category.label }}</span>
                        <span class="count">{{ category.count }}</span>
                      </button>
                    </div>
                    <div class="campaign-content-tags">
                      <div v-for="tag in adSelectedTags" :key="tag" class="campaign-content-tag">
                        <span class="tag-text">{{ tag }}</span>
                      </div>
                    </div>
                    <div class="campaign-content-divider"></div>
                    <div class="campaign-content-input-header">
                      <p class="title">{{ $t('registration.detailTarget.ad.manualInput') }}</p>
                      <p class="desc">{{ $t('registration.detailTarget.ad.manualInputDesc') }}</p>
                    </div>
                    <div class="campaign-content-input-wrap" :class="{ 'has-error': Boolean(adInputErrorMessage) }">
                      <ui-input-text
                        :type="'text'"
                        :isInputAbove="false"
                        labelPosition="left"
                        :modelValue="adCustomParameterInput"
                        :placeholder="$t('registration.detailTarget.ad.inputPlaceholder')"
                        :error="adInputErrorMessage"
                        @input="onInputAdCustomParameter"
                        @onEnter="onSubmitAdCustomParameter"
                      />
                    </div>
                    <div v-if="adCustomParameters.length" class="campaign-content-tags">
                      <div v-for="tag in adCustomParameters" :key="tag" class="campaign-content-tag removable">
                        <span class="tag-text">{{ tag }}</span>
                        <button type="button" class="tag-remove" @click="removeAdCustomParameter(tag)">
                          <i class="icon icon--close-size24 size-8"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <transition name="slide-fade">
                <div class="step-footer" :class="{'timezoneEdit' : isTimezoneChange}">
                  <ui-button v-if="!isEditMode"
                             :primary="true"
                             :size="'xlarge'"
                             :disabled="!isStep2Submit || (customUse && !model.beuCustomId) || !!modelError.beuCustomId"
                             :loading="registering"
                             :iconName="'icon--check-white'"
                             @click="onConfirm">{{ $t('common.register') }}</ui-button>
                  <ui-button v-else
                             :primary="true"
                             :size="'xlarge'"
                             :disabled="(customUse && !model.beuCustomId) || !!modelError.beuCustomId || !stepCompleted.step2 || !isAgree"
                             :loading="registering"
                             :iconName="'icon--check-white'"
                             @click="onConfirm">{{ $t('common.edit') }}</ui-button>
                </div>
              </transition>
            </div>
          </div>

          <div class="seperator"></div>

          <div class="right-side">
            <div class="guide">
              <div class="carousel">
                <div class="carousel-control">
                  <button class="prev"
                          :class="{ disabled: carouselIndex <= 0 }"
                          @click="prevCarousel">
                    <i class="icon icon--arrow-left-white"></i>
                  </button>
                  <button class="next"
                          :class="{ disabled: carouselIndex >= 4 }"
                          @click="nextCarousel">
                    <i class="icon icon--arrow-right-white"></i>
                  </button>
                  <div class="carousel-navigation">
                    <button v-for="idx in [0, 1, 2, 3, 4]"
                            v-bind:key="'navi' + idx"
                            :class="{ active: idx === carouselIndex }"
                            @click="setCarouselIndex(idx)"></button>
                  </div>
                </div>
                <div class="carousel-body">
                  <div class="carousel-board" :style="carouselBodyStyle">
                    <div class="carousel-content">
                      <div class="c c1">
                        <div class="image" :class="$i18n.locale"></div>
                        <h5 v-html="$t('registration.guide.step1.title')"></h5>
                        <p v-html="$t('registration.guide.step1.description')"></p>
                      </div>
                    </div>
                    <div class="carousel-content">
                      <div class="c c2">
                        <div class="image" :class="$i18n.locale"></div>
                        <h5 v-html="$t('registration.guide.step2.title')"></h5>
                        <p v-html="$t('registration.guide.step2.description')"></p>
                      </div>
                    </div>
                    <div class="carousel-content">
                      <div class="c c3">
                        <h5 v-html="$t('timezone.registration.guide.title')"></h5>
                        <p v-html="$t('timezone.registration.guide.description')"></p>
                      </div>
                    </div>
                    <div class="carousel-content">
                      <div class="c c4">
                        <h5 v-html="$t('registration.guide.step3.title')"></h5>
                        <p v-html="$t('registration.guide.step3.description')"></p>
                      </div>
                    </div>
                    <div class="carousel-content" v-if="!isExact">
                      <div class="link">
                        <a :href="onCustomTagGuideLink()" target="_blank">
                          <i class="icon icon--ba-link white"></i>
                          <span>{{ $t('registration.detailTarget.guide.title') }}</span>
                        </a>
                      </div>
                      <div class="c c5">
                        <div class="image" :class="$i18n.locale"></div>
                        <h5 v-html="$t('registration.guide.step4.title')"></h5>
                        <p v-html="$t('registration.guide.step4.description')"></p>
                      </div>
                    </div>
                    <div class="carousel-content" v-else>
                      <div class="c c6">
                        <div class="image" :class="$i18n.locale"></div>
                        <h5 v-html="$t('registration.guide.step5.title')">
                        </h5>
                        <p v-html="$t('registration.guide.step5.description')"></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slide-fade">
      <div class="tracking-code-wrap"
           v-show="showTrackingCode">
        <tracking-code-guide v-if="model.sid"
                             :sid="model.sid" />
      </div>
    </transition>

    <dimmed v-if="notMultiDomain">
      <alert :title="$t('registration.noMultiDomain.title')"
             :description="$t('registration.noMultiDomain.description')"
             :submit="$t('common.confirm')"
             @onSubmit="notMultiDomain = false" />
    </dimmed>

    <dimmed v-if="!isTimezoneEdit">
      <timezone-no-edit @check="onChangeTimezoneNoEditConfirm"
                        :timezoneName="model.timezoneName"
                        :domain="model.domain">

      </timezone-no-edit>
    </dimmed>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import { insertDomain, validateDomain, getData, getAdParamConfig, updateAdParamConfig } from '@/api/domain'
import { getDomainForData, getDomainForView, getOffset, thousand } from '@/libs/utils'
import { EventBus } from '@/libs/event-bus'
import TrackingCodeGuide from '@/components/dashboard/TrackingCodeGuide'
import UiIconTooltip from '@/components/ui/UiIconTooltip'
import UiInputText from '@/components/ui/UiInputText'
import UiSelectbox from '@/components/ui/UiSelectbox'
import UiButton from '@/components/ui/UiButton'
import BaSwitch from '@/components/ui/ba/Switch'
import Dimmed from '@/components/ui/Dimmed'
import Alert from '@/components/ui/Alert'
import UiCheckbox from '@/components/ui/UiCheckbox.vue'
import TimezoneSelectbox from '@/components/ui/TimezoneSelectbox.vue'
import { validateTimezone } from '@/api/timezone'
import TimezoneNoEdit from '@/components/dashboard/TimezoneNoEdit.vue'
import UiRadio from '@/components/ui/UiRadio.vue'
import { isCustomIdCheck } from '@/libs/validation-helper'
import { CUSTOM_DEFAULT_ID } from '@/libs/constants'
import {
  getAdParamCategories,
  getAdParamTagMap,
  getAllDefaultAdParamKeys,
  normalizeAdParamKeys
} from '@/libs/ad-param-config'

export default {
  name: 'AddDomain',
  components: {
    UiRadio,
    TimezoneNoEdit,
    TimezoneSelectbox,
    UiCheckbox,
    BaSwitch,
    Alert,
    TrackingCodeGuide,
    UiIconTooltip,
    UiInputText,
    UiSelectbox,
    UiButton,
    Dimmed
  },
  created () {
    EventBus.$emit('onLoading', false)

    if (this.isEditMode) {
      EventBus.$emit('setTitle', this.$t('registration.editModeTitle'))
      this.setCarouselIndex(1)
      this.setStepCompleted(2, true)
      let sid = this.$route.query.sid
      getData(sid, true).then(result => {
        this.model.sid = result.orgSid || result.sid
        this.model.realUrl = result.realUrl || result.domain
        this.model.domain = result.domain
        this.model.domainName = result.domainName
        this.model.matchType = result.matchType
        this.model.beuCustomId = result.beuCustomId

        validateTimezone({ domain: result.domain }).then(domainCheck => {
          this.isTimezoneChange = domainCheck.updatable && !this.isExact
          if (!this.isTimezoneChange) {
            this.isAgree = true
          }

          this.step = 2
          this.model.pvLimit = result.nextPvLimit

          this.originalPvLimit = result.pvLimit

          this.model.timezone = getOffset(result.timezoneName)
          this.model.timezoneName = result.timezoneName

          const pvItem = this.pvLimitOptionList.find(item => {
            return item.value !== 0 && item.value === this.model.pvLimit
          })
          const pvLimit = pvItem ? pvItem.value : 0
          this.internalPvLimit = pvLimit
          if (this.internalPvLimit === 0) {
            this.customPvLimit = this.model.pvLimit
          }
        })

        if (result.matchType === 'exact') {
          this.loadAdParamConfig()
        }
      })
    } else {
      EventBus.$emit('setTitle', this.$t('registration.title'))
      const pvItem = this.pvLimitOptionList.find(item => {
        return item.value !== 0 && item.value === this.model.pvLimit
      })
      const pvLimit = pvItem ? pvItem.value : 0
      this.internalPvLimit = pvLimit

      if (this.internalPvLimit === 0) {
        this.customPvLimit = this.model.pvLimit
      }

      this.step = 1
    }
    setTimeout(() => {
      if (this.step === 2) {
        this.showFooter = true
      }
    }, 500)
  },
  watch: {
    step () {
      this.animating = true
      setTimeout(() => {
        this.animating = false
        if (this.step === 2) {
          this.showFooter = true
        } else {
          this.showFooter = false
        }
      }, 300)
    },
    detailTarget () {
      this.$nextTick(() => this.updateAdContentGradient())
    },
    isAdToggleOn () {
      this.$nextTick(() => this.updateAdContentGradient())
    },
    adSelectedCategory () {
      this.$nextTick(() => this.updateAdContentGradient())
    },
    adCustomParameters: {
      handler () {
        this.$nextTick(() => this.updateAdContentGradient())
      },
      deep: true
    },
    defaultAdParams: {
      handler () {
        this.$nextTick(() => this.updateAdContentGradient())
      },
      deep: true
    }
  },
  methods: {
    onCustomTagGuideLink () {
      if (this.$i18n.locale === 'ja') {
        return 'https://forum.beusable.net/ja/solomon/post/2313'
      } else if (this.$i18n.locale === 'en') {
        return 'https://forum.beusable.net/en/solomon/post/2312'
      } else {
        return 'https://forum.beusable.net/ko/solomon/post/2311'
      }
    },
    updateAdContentGradient () {
      const container = this.$refs.adContent

      if (!container) {
        this.adHasTopGradient = false
        this.adHasBottomGradient = false
        return
      }

      const { scrollTop, clientHeight, scrollHeight } = container
      const maxScrollTop = Math.max(scrollHeight - clientHeight, 0)
      const tolerance = 1

      this.adHasTopGradient = scrollTop > tolerance
      this.adHasBottomGradient = maxScrollTop - scrollTop > tolerance
    },
    loadAdParamConfig () {
      const sid = this.model.sid

      if (!sid) {
        return Promise.resolve()
      }

      return getAdParamConfig({ sid }, true)
        .then(result => {
          this.isAdToggleOn = Boolean(result.enabled)
          this.defaultAdParams = result.defaultAdParams || []
          this.adCustomParameters = normalizeAdParamKeys(result.customAdParams)
          this.originalAdCustomParameters = [...this.adCustomParameters]
          this.$nextTick(() => this.updateAdContentGradient())
        })
        .catch(() => {
          this.defaultAdParams = []
          this.adCustomParameters = []
          this.originalAdCustomParameters = []
          this.$nextTick(() => this.updateAdContentGradient())
        })
    },
    saveAdParamConfig () {
      if (!this.model.sid) {
        return Promise.resolve()
      }

      const currentCustomAdParams = normalizeAdParamKeys(this.adCustomParameters)
      const originalCustomAdParams = normalizeAdParamKeys(this.originalAdCustomParameters)
      const payload = {
        sid: this.model.sid,
        enabled: this.isAdToggleOn,
        addParams: currentCustomAdParams.filter(param => !originalCustomAdParams.includes(param)),
        removeParams: originalCustomAdParams.filter(param => !currentCustomAdParams.includes(param))
      }

      return updateAdParamConfig(payload, true).then(result => {
        this.isAdToggleOn = Boolean(result.enabled)
        this.adCustomParameters = normalizeAdParamKeys(result.customAdParams)
        this.originalAdCustomParameters = [...this.adCustomParameters]
      })
    },
    onCustomUseChange (use) {
      this.customUse = use
      if (use) {
        if (!this.model.beuCustomId) {
          this.model.beuCustomId = CUSTOM_DEFAULT_ID
        }
      }
      if (!use) {
        this.modelError.beuCustomId = ''
      }
    },
    onChangeTimezoneNoEditConfirm () {
      this.isTimezoneEdit = true
      let model = {}
      if (this.isEditMode) {
        model.sid = this.model.sid
      } else {
        model.domain = this.model.domain
        model.realUrl = this.model.realUrl
        model.matchType = this.model.matchType
      }
      model.domainName = this.model.domainName
      model.timezone = getOffset(this.model.timezoneName)
      model.timezoneName = this.model.timezoneName
      if (this.isPaidPlan) {
        model.pvLimit = this.model.pvLimit
      }
      model.beuCustomId = this.customUse ? this.model.beuCustomId : null
      if (this.internalPvLimit !== this.originalPvLimit) {
        this.toDashboard()
        return true
      }
      this.onLastInsertDomain(model)
    },
    onChangeTimezone (value) {
      this.model.timezone = value.timezone
      this.model.timezoneName = value.timezoneName
    },
    thousand (value) {
      return thousand(value)
    },
    toDashboard () {
      EventBus.$emit('onLoading', true)
      setTimeout(() => {
        let query = {}
        if (this.model.sid) {
          query.sid = this.model.sid
        }
        this.$router.push({ name: 'dashboard', query })
      }, 300)
    },
    goStep (step) {
      if (!(this.isEditMode && step === 1)) {
        if (this.step !== step) {
          if (step < this.step || this.stepCompleted['step' + this.step]) {
            this.step = step
            if (step === 1) {
              this.setCarouselIndex(0)
            } else if (step === 2) {
              this.setCarouselIndex(1)

              validateTimezone({ domain: this.model.domain }).then(domainCheck => {
                this.isTimezoneChange = domainCheck.updatable && !this.isExact
                if (!this.isEditMode && !this.isTimezoneChange) {
                  this.isAgree = true
                }

                this.model.timezone = getOffset(domainCheck.timezoneName)
                this.model.timezoneName = domainCheck.timezoneName
              })
            }
          }
        } else {
          this.goStep(this.step % 2 + 1)
        }
      }
    },
    setCarouselIndex (idx) {
      this.carouselIndex = idx
    },
    prevCarousel () {
      if (this.carouselIndex > 0) {
        this.carouselIndex--
      }
    },
    nextCarousel () {
      if (this.carouselIndex < 4) {
        this.carouselIndex++
      }
    },
    setDomain (value) {
      this.setStepCompleted(1, false)
      if (value) {
        this.allowValidation = true
      } else {
        this.allowValidation = false
      }
      this.model.realUrl = value
      this.model.viewRealUrl = getDomainForView(value)
    },
    setDomainName (value) {
      this.model.domainName = value
    },
    setBeuCustomId (value) {
      if (this.customUse && value === '') {
        this.modelError.beuCustomId = 'empty'
        return false
      }
      if (value.indexOf(' ') > -1) {
        this.modelError.beuCustomId = 'noEmptyCustomId'
        return false
      }

      if (!isCustomIdCheck(value)) {
        this.modelError.beuCustomId = 'onlyAlphaSpecCustomId'
        return false
      } else {
        this.modelError.beuCustomId = ''
      }

      this.model.beuCustomId = value
    },
    onValidateUrl () {
      this.validating = true

      // this.model.viewRealUrl = getDomainForView(this.model.viewRealUrl)
      this.model.realUrl = getDomainForData(this.model.viewRealUrl)

      const pieces = this.model.realUrl.trim().split('.')
      if (pieces.length < 2) {
        this.validating = false
        this.setStepCompleted(1, false)
        this.allowValidation = false
        this.modelError.domain = 'unAbleDomain'
      } else {
        if (this.model.realUrl.substr(0, 4) !== 'http') {
          this.model.realUrl = 'http://' + this.model.realUrl
        }

        validateDomain({
          url: this.model.realUrl.trim()
        }, true).then(result => {
          this.validating = false
          if (result && result.success && result.root_domain) {
            this.setStepCompleted(1, true)
            this.model.domain = result.root_domain
            this.model.realUrl = this.model.domain
          } else if (result && result.message === 'DOMAIN_EXISTS') {
            this.setStepCompleted(1, false)
            this.model.domain = result.root_domain
            this.model.realUrl = this.model.domain
            this.modelError.domain = 'existDomain'
            this.allowValidation = false
          } else {
            this.setStepCompleted(1, false)
            this.allowValidation = false
            this.modelError.domain = 'unAbleDomain'
          }
        }).catch(() => {
          this.validating = false
          this.setStepCompleted(1, false)
          this.allowValidation = false
          this.modelError.domain = 'unAbleDomain'
        })
      }
    },
    setStepCompleted (step, status) {
      this.$set(this.stepCompleted, 'step' + step, status)
    },
    checkCustomPvLimit (value) {
      if (!value) {
        this.setStepCompleted(2, false)
      } else {
        const realValue = parseInt(value) || 1
        if (this.customPvLimit !== realValue) {
          this.customPvLimit = realValue
          this.model.pvLimit = realValue
        }
        this.setStepCompleted(2, true)
      }
    },
    onPVLimitChange (value) {
      this.internalPvLimit = value
      const pvLimit = this.internalPvLimit === 0 ? this.defaultCustomPvLimit : value
      this.customPvLimit = pvLimit
      this.model.pvLimit = pvLimit
    },
    onConfirm () {
      if (!this.isAgree || !this.model.timezone) {
        return false
      }
      this.registering = true
      let model = {}
      if (this.isEditMode) {
        model.sid = this.model.sid
      } else {
        model.domain = this.model.domain
        model.realUrl = this.model.realUrl
        model.matchType = 'simple'
      }
      model.domainName = this.model.domainName
      model.timezone = this.model.timezone
      model.timezoneName = this.model.timezoneName
      model.pvLimit = this.model.pvLimit
      model.beuCustomId = this.customUse ? this.model.beuCustomId : ''

      let isEdit = true

      validateTimezone({ domain: this.model.domain }).then(result => {
        isEdit = result.updatable
        if (isEdit) {
          this.onLastInsertDomain(model)
        } else {
          this.isTimezoneEdit = false
          model.timezone = result.timezone
          model.timezoneName = result.timezoneName
          this.model.timezone = result.timezone
          this.model.timezoneName = result.timezoneName
          if (this.internalPvLimit !== this.originalPvLimit) {
            this.onLastInsertDomain(model, true)
          }
        }
      })
    },
    onLastInsertDomain (model, boolean) {
      insertDomain(model, true).then(result => {
        if (result && (result.orgSid || result.sid)) {
          this.model.sid = result.orgSid || result.sid

          const done = () => {
            this.registering = false
            if (!this.isEditMode) {
              this.showTrackingCode = true
            } else if ((this.internalPvLimit !== this.originalPvLimit) && boolean) {
              return true
            } else {
              this.toDashboard()
            }
            return true
          }

          if (this.isEditMode && this.isExact) {
            return this.saveAdParamConfig().then(() => done())
          }

          done()
        } else {
          this.registering = false
        }
      }).catch((e) => {
        const message = e.message
        this.registering = false
        if (message === 'USER IS NOT ALLOWED TO HAVE MULTI DOMAIN') {
          this.notMultiDomain = true
        }
      })
    },
    onTapSelect (item) {
      this.detailTarget = item
      if (item === 'custom') {
        if (this.isEditMode) {
          this.customUse = !!this.model.beuCustomId
        } else {
          this.customUse = false
        }
      }
    },
    clearAdInputError () {
      this.adInputErrorMessage = ''
    },
    onInputAdCustomParameter (value) {
      this.adCustomParameterInput = value
      this.clearAdInputError()
    },
    clearAdCustomParameterInput () {
      this.adCustomParameterInput = ''
      this.clearAdInputError()
    },
    removeAdCustomParameter (tag) {
      this.adCustomParameters = this.adCustomParameters.filter(item => item !== tag)
    },
    onSubmitAdCustomParameter () {
      const value = this.adCustomParameterInput.trim()

      if (!value) {
        this.clearAdCustomParameterInput()
        return
      }

      if (!/^[A-Za-z0-9_.-]+$/.test(value)) {
        this.adInputErrorMessage = this.$t('registration.detailTarget.ad.inputErrorInvalid')
        return
      }

      if (value.length > 30) {
        this.adInputErrorMessage = this.$t('registration.detailTarget.ad.inputErrorMaxLength')
        return
      }

      if (this.allDefaultAdParamKeys.includes(value) || this.adCustomParameters.includes(value)) {
        this.adInputErrorMessage = this.$t('registration.detailTarget.ad.inputErrorDuplicate')
        return
      }

      this.adCustomParameters.push(value)
      this.clearAdCustomParameterInput()
    }
  },
  computed: {
    ...mapState([
      'planData',
      'userData'
    ]),
    pvLimitOptionList () {
      return [
        { value: 10000, text: '10,000' },
        { value: 20000, text: '20,000' },
        { value: 30000, text: '30,000' },
        { value: 50000, text: '50,000' },
        { value: 100000, text: '100,000' },
        {
          value: 0,
          text: this.$t('common.directInput')
        },
        {
          value: -1,
          text: this.$t('common.noLimit')
        }
      ]
    },
    isCustomUser () {
      const allowUserIds = ['admin', 'samsung_gmc', 'app.admin@wadiz.kr', 'btmall@btmall.kr']
      return allowUserIds.indexOf(this.userData.userId) > -1
    },
    isStep2Submit () {
      if (this.customUse) {
        if (this.model.beuCustomId === '') {
          return false
        }
      }
      return this.model.domainName && this.isAgree && this.model.timezone
    },
    isPaidPlan () {
      return !this.planData.bFree
    },
    isEditMode () {
      return this.$route.name === 'edit' && this.$route.query.sid
    },
    isExact () {
      return this.model.matchType === 'exact'
    },
    pvWarning () {
      if (!this.isEditMode) {
        return false
      }
      if (this.originalPvLimit === this.model.pvLimit) {
        return false
      }
      if (this.model.pvLimit === -1) {
        return false
      }
      return this.originalPvLimit === -1 || this.originalPvLimit > this.model.pvLimit
    },
    carouselBodyStyle () {
      return { transform: `translateX(${-480 * this.carouselIndex}px)` }
    },
    adParameterCategories () {
      return getAdParamCategories(this.defaultAdParams)
    },
    adSelectedTags () {
      const tagMap = getAdParamTagMap(this.defaultAdParams)
      return tagMap[this.adSelectedCategory] || []
    },
    allDefaultAdParamKeys () {
      return getAllDefaultAdParamKeys(this.defaultAdParams)
    }
  },
  data () {
    return {
      step: 0,
      carouselIndex: 0,
      animating: false,
      model: {
        sid: null,
        domain: '',
        realUrl: '',
        matchType: '',
        domainName: '',
        timezone: '',
        timezoneName: '',
        pvLimit: -1,
        beuCustomId: CUSTOM_DEFAULT_ID,
        viewRealUrl: ''
      },
      modelError: {
        domain: '',
        domainName: '',
        beuCustomId: ''
      },
      stepCompleted: {
        step1: false,
        step2: false
      },
      isAdToggleOn: true,
      adSelectedCategory: 'utm',
      adCustomParameterInput: '',
      adCustomParameters: [],
      originalAdCustomParameters: [],
      defaultAdParams: [],
      adInputErrorMessage: '',
      notMultiDomain: false,
      validating: false,
      registering: false,
      showTrackingCode: false,
      allowValidation: false,
      originalPvLimit: null,
      internalPvLimit: null,
      customPvLimit: null,
      defaultCustomPvLimit: 10000,
      isTimezoneChange: true,
      isAgree: false,
      isTimezoneEdit: true,
      showFooter: false,
      detailTarget: 'report',
      customUse: false,
      adHasTopGradient: false,
      adHasBottomGradient: false
    }
  }
}
</script>

<style lang="scss" scoped>
.add-domain {
  &.edit-mode {
    .left-side .step.step-1 .step-title {
      cursor: not-allowed;

      span .hide-on-active {
        color: #767676;
      }
    }
  }

  .add-domain-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1252px;
    height: 700px;
  }

  .add-header {
    margin: 20px 0;

    .ui-btn {
      border: none;
      box-shadow: 0 9px 11px -5px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.08);
      font-size: 13px;
      height: 34px;
    }
  }

  .add-body {
    margin: 20px 0;
  }

  .left-side {
    display: inline-block;
    vertical-align: top;
    height: 665px;

    .step {
      width: 740px;
      height: 64px;
      border-radius: 14px;
      box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
      background-color: #ffffff;
      margin-bottom: 23px;
      overflow: hidden;
      transition: height 0.5s ease;
      &.active {
        .step-title {
          &.complete {
            &::after {
              transform: scaleY(-1);
              background-image: url(../../assets/img/common/icon--arrow-up-black.svg);
            }
          }
        }
      }

      .step-title {
        color: #2f2f2f;
        font-weight: 500;
        font-size: 16px;
        padding: 16px 15px 18px 15px;
        cursor: pointer;
        position: relative;

        &.complete {
          &::after {
            transform: scaleY(1);
            background-image: url(../../assets/img/common/icon--arrow-up-black.svg);
          }
        }

        &::after {
          position: absolute;
          top: 20px;
          right: 20px;
          content: "";
          width: 20px;
          height: 20px;
          background-image: url(../../assets/img/common/icon--arrow-up-gray.svg);
          transform: scaleY(-1);
          transition: transform 0.3s ease;
        }

        i {
          display: inline-block;
          vertical-align: middle;
          width: 20px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          font-weight: normal;
          color: #666666;
          padding: 5px;
          border: solid 1px #d7d7d7;
          border-radius: 30px;
          margin-right: 10px;
          transition: all 0.3s ease;

          &.complete {
            background-image: url(../../assets/img/common/icon--check-white-small.svg);
            background-color: #57ab00;
            background-repeat: no-repeat;
            background-position: center;
            border-color: #57ab00;
            color: transparent;
          }
        }

        span {
          vertical-align: middle;
          display: inline-block;
          white-space: nowrap;
          line-height: 32px;

          .show-on-active {
            width: 0;
            opacity: 0;
            vertical-align: top;
            display: inline-block;
            overflow: hidden;
            transition: width 0.3s ease, opacity 0.3s ease;
          }

          .hide-on-active {
            width: 440px;
            opacity: 1;
            vertical-align: top;
            display: inline-block;
            overflow: hidden;
            transition: width 0.3s ease, opacity 0.3s ease;
            font-size: 14px;
            color: #ec0047;
            padding-left: 60px;
          }
        }
      }

      .step-content {
        width: 100%;
        height: 330px;
        margin: 0 auto;
        text-align: center;
        box-sizing: border-box;
        padding: 46px 40px 36px 40px;

        &.timezoneEdit {
          padding-top: 0 !important;
        }

        .form {
          position: relative;

          &.timezoneEdit {
            padding-top: 0;

            &.custom {
              margin-top: 0;
              padding-top: 40px;
              padding-left: 80px;
            }
          }

          .validation {
            position: absolute;
            top: 44px;
            right: -10px;

            .icon {
              position: absolute;
              top: 1px;
              left: 0;
              opacity: 0;
              transition: opacity 0.2s ease;
            }

            &.pass .icon.icon--validation-pass {
              opacity: 1;
            }

            &.fail .icon.icon--validation-alert {
              opacity: 1;
            }
          }

          .option {
            position: relative;
            display: flex;
            text-align: left;
            margin-top: 32px;
            align-items: center;

            &.input {
              margin-top: 70px;
              &.edit {
                margin-top: 90px;
              }
            }

            & .input--wrap {
              margin-top: 0;
              & /deep/ {
                .above-input {
                  margin-top: 0;
                }
              }
            }

            .custom-use-check-radios {
              display: flex;
              width: 70%;
              gap: 40px;
              align-items: flex-start;
              text-align: left;
              .item {
                position: relative;
                display: flex;
                flex-direction: column;
                text-align: left;
                .desc {
                  position: absolute;
                  display: inline-flex;
                  white-space: nowrap;
                  left: 0;
                  top: 36px;
                  color: #767676;
                  font-size: 13px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 19px; /* 146.154% */

                  &.next {
                    top: 55px
                  }
                }
                & .ui_radio {
                  &:nth-last-of-type(1) {
                    margin-left: 0;
                  }
                }
              }
            }

            &.timezoneEdit {
              margin-top: 30px;
            }

            & .timezone-desc {
              padding: 12px 0 0 25px;

              & ul {
                list-style: square;

                li {
                  text-align: left;
                  font-size: 14px;
                  line-height: 1.43;
                  color: #2f2f2f;
                  padding-bottom: 5px;

                  & .highlight {
                    color: #ec0047;
                  }
                }
              }
            }
            & .timezone-agree {
              padding: 8px 0 0 25px;
              text-align: left;

              .terms-agree {
                position: relative;
                top: 1px;
              }

              .ui_checkbox {
                margin-left: 0px;
              }
            }

            & span.value {
              display: inline-block;
              padding-left: 5px;
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              line-height: 1;
              letter-spacing: normal;
              color: #2f2f2f;
            }

            &.warning {
              & /deep/ .ui_select .item--wrap,
              & /deep/ .input--wrap input {
                border-color: #ee7b00;
              }
            }

            &.less {
              margin-bottom: -48px;
            }

            .pv-warning {
              position: absolute;
              top: 38px;
              left: 0;
              margin: 3px 0 0 180px;
              font-size: 12px;
              line-height: 1.33;
              color: #ee7b00;
              white-space: nowrap;
            }

            .label {
              font-weight: 500;
              font-size: 13px;
              color: #767676;
              min-width: 127px;
              display: flex;
              align-items: center;

              &.top {
                height: 100%;
                position: absolute;
                vertical-align: top;
                display: inline-block;
                top: 14px;
              }

              &.custom {
                display: inline-block;
                &.empty {
                  visibility: hidden;
                }
              }

              .tip {
                display: inline-block;
                height: 17px;
                margin-left: 5px;
              }

              .pro {
                position: relative;
                display: inline-block;
                font-size: 11px;
                color: #ffffff;
                padding: 3px 6px 2px 6px;
                border-radius: 3px;
                background-color: #9a72d2;
                vertical-align: middle;
                margin: -5px 0 -2px 5px;
                cursor: default;

                .bubble {
                  @include positionXcenter;
                  bottom: 26px;
                  pointer-events: none;
                  opacity: 0;
                  transform: translate(-50%, 15px);
                  transition: opacity 0.15s ease,
                  transform 0.15s ease;
                }

                &:hover {
                  .bubble {
                    opacity: 1;
                    transform: translate(-50%, 0);
                  }
                }
              }
            }

            .content {
              display: inline-flex;
              width: 100%;
              margin-right: 58px;
              position: relative;
              &.top {
                margin-left: 127px;
                display: inline-block;
              }
              &.customInput {
                margin-right: 0;
              }

              .item {
                position: relative;
                display: inline-block;
                width: calc(100% - 150px);
                &.customEdit {
                  width: 130px;
                  margin-left: 20px;
                  top: 5px;
                }
                &.customRadio {
                  width: initial;
                }
                & span {
                  display: inline-block;
                  margin-bottom: 3px;
                }
              }
            }

            .radio-label {
              display: inline-block;
              color: #444444;
              font-size: 14px;
              margin: 17px 27px 0 2px;
              cursor: pointer;

              &.disabled {
                cursor: default;
              }

              .icon {
                vertical-align: middle;
                transform: translateY(-1px);
                margin-right: 3px;
                margin-left: 5px;
              }
            }
            .pv-range {
              position: relative;
              /deep/ label {
                display: none;
              }

              /deep/ span.name {
                vertical-align: initial;
              }
            }

            .pv-edit {
              position: relative;

              .input--wrap {
                width: 145px;
                margin-top: 0;

                & /deep/ {
                  .above-input {
                    margin-top: 0;
                  }

                  .label {
                    display: none;
                  }
                }
              }

              .icon {
                vertical-align: middle;
                margin: 0 5px;
              }
            }

            .pv-edit-box {
              display: flex;
            }

            .custom-input {
              position: relative;
              display: inline-block;
              width: 145px;

              .input {
                //vertical-align: middle;
                display: inline-block;
                width: 145px;
                margin-left: 5px;

                & /deep/ {
                  .above-input {
                    margin-top: 0;
                  }

                  .label {
                    display: none;
                  }
                }
              }

              .unit {
                position: absolute;
                top:50%;
                left: 155px;
                transform: translate(0, -50%);
                vertical-align: middle;
                display: inline-block;
              }
            }
          }
        }

        .note {
          margin-top: 40px;
          border-radius: 10px;
          background-color: #f4f4f4;
          position: relative;
          padding: 1px 0;

          h5 {
            position: absolute;
            top: 12px;
            left: 12px;
            border-radius: 3px;
            background-color: #1199af;
            font-weight: normal;
            color: #ffffff;
            padding: 3px 4px;
            font-size: 11px;
            text-transform: uppercase;
          }

          .description {
            margin: 26px 15px 15px 15px;
            font-size: 13px;
            color: #a47e40;
          }

          .example {
            margin: 15px 15px 29px 15px;
            font-size: 14px;
            font-weight: 500;
            color: #666666;

            mark {
              padding: 2px 0;
              background-color: rgba(252, 0, 78, 0.23);
            }
          }
        }
      }

      .step-footer {
        text-align: center;

        .button-wrap {
          display: inline-block;
          width: 0;
          opacity: 0;
          overflow: hidden;
          transition: width 0.5s ease, opacity 0.3s ease;
          border-radius: 30px;

          &.show {
            width: 100%;
            opacity: 1;
          }
        }
      }

      &.step-1 {
        .step-content {
          width: 480px;
          padding: 46px 0 0 0;
        }
      }

      &.step-2 {
        .report-custom-tap {
          display: flex;
          height: 44px;
          margin: 0 30px;
          font-size: 15px;
          font-style: normal;
          font-weight: 500;
          line-height: 100%;
          position: relative;
          .tap {
            position: relative;
            padding: 16px 5px 7px 5px;
            color: #999;
            cursor: pointer;
            &.on {
              color: #2F2F2F;
              &::after {
                content: "";
                position: absolute;
                display: block;
                width: 100%;
                height: 3px;
                background-color: #EC0047;
                bottom: 0;
                left: 0;
                z-index: 5;
              }
            }
            &.main {
              margin-right: 40px;
            }
          }
          &::after {
            content: "";
            position: absolute;
            display: block;
            width: 100%;
            height: 1px;
            background-color: #D7D7D7;
            bottom: 0;
          }
        }

        .step-content {
          margin-top: 0;
          padding-top: 78px;

          &.custom {
            padding-left: 80px;
            padding-top: 53px;
          }

          &.ad {
            text-align: left;
            padding-top: 24px;
            padding-left: 30px;
            .campaign-header {
              display: flex;
              align-items: center;
              gap: 12px;
              margin-bottom: 16px;

              &-title {
                display: flex;
                align-items: center;
                gap: 4px;

                p {
                  color: #2f2f2f;
                  font-size: 14px;
                  font-weight: 500;
                  line-height: 1;
                }

                .icon--info-outline-gray {
                  filter: brightness(0.67);
                }
              }
              :deep(.ba-switch) {
                button label {
                  top: 1px;
                }
              }
            }

            .campaign-content-wrap {
              position: relative;
              width: 100%;
              height: 291px;

              &::before,
              &::after {
                content: '';
                position: absolute;
                left: 20px;
                right: 20px;
                height: 20px;
                pointer-events: none;
                opacity: 0;
                transition: opacity 0.2s ease;
                z-index: 2;
              }

              &::before {
                top: 1px;
                background: linear-gradient(180deg, #f4f4f4 50%, rgba(244, 244, 244, 0) 100%);
              }

              &::after {
                bottom: 1px;
                background: linear-gradient(180deg, rgba(244, 244, 244, 0) 0%, #f4f4f4 50%);
              }

              &.show-top-gradient::before {
                opacity: 1;
              }

              &.show-bottom-gradient::after {
                opacity: 1;
              }
            }

            .campaign-content {
              display: flex;
              flex-direction: column;
              gap: 20px;
              width: 100%;
              height: 100%;
              padding: 20px;
              border: 1px solid #d7d7d7;
              border-radius: 5px;
              background: #f4f4f4;
              overflow-y: auto;
              box-sizing: border-box;

              &::-webkit-scrollbar {
                width: 12px;
              }

              &::-webkit-scrollbar-thumb {
                background: #c3c3c3;
                border-radius: 16px;
                border: 2px solid transparent;
                background-clip: padding-box;
              }

              &::-webkit-scrollbar-track {
                background: none;
                border-left: 4px solid transparent;
              }

              &-title {
                color: #2f2f2f;
                font-size: 14px;
                font-weight: 400;
                line-height: 1;
              }

              &-tabs {
                display: flex;
                align-items: stretch;
                width: fit-content;
                min-height: 36px;
                border: 1px solid #e0e0e0;
                border-radius: 6px;
                overflow: hidden;
                background: #fff;
              }

              &-tab {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 4px;
                min-width: 64px;
                min-height: 36px;
                padding: 0 10px;
                border-right: 1px solid #e0e0e0;
                background: #fff;
                color: #555;
                font-size: 13px;
                font-weight: 400;
                line-height: 1;
                text-align: center;
                box-sizing: border-box;

                &:last-child {
                  border-right: 0;
                }

                .count {
                  color: #888;
                }

                &.active {
                  background: #ec0047;
                  color: #fff;

                  .count {
                    color: rgba(255, 255, 255, 0.76);
                  }

                  &:after {
                    content: '';
                    position: absolute;
                    inset: 0;
                    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.35);
                    pointer-events: none;
                  }
                }
              }

              &-tags {
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                width: 100%;
              }

              &-divider {
                flex-shrink: 0;
                width: 100%;
                height: 1px;
                background: #ccc;
              }

              &-tag {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                height: 20px;
                padding: 0 8px;
                border: 1px solid #ccc;
                border-radius: 999px;
                background: #fff;
                box-sizing: border-box;

                .tag-text {
                  color: #777;
                  font-size: 13px;
                  font-weight: 400;
                  line-height: 1;
                  white-space: nowrap;
                }

                &.removable {
                  gap: 6px;
                  padding-right: 4px;
                }

                .tag-remove {
                  @include flexXYcenter;
                  width: 12px;
                  height: 12px;
                }
              }

              &-divider {
                width: 100%;
                height: 1px;
                background: #ccc;
              }

              &-input-header {
                display: flex;
                align-items: flex-end;
                gap: 8px;
                line-height: 1;

                .title {
                  color: #2f2f2f;
                  font-size: 14px;
                  font-weight: 600;
                }

                .desc {
                  color: #777;
                  font-size: 12px;
                  font-weight: 400;
                }
              }

              &-input-wrap {
                width: 420px;

                &.has-error {
                  margin-bottom: 16px;
                }

                & /deep/ {
                  .input--wrap {
                    .label {
                      display: none;
                    }

                    .input-element {
                      input {
                        padding: 0 40px 0 11px;
                        border-radius: 5px;
                        line-height: 1;
                      }

                      .validation-text {
                        padding-left: 4px;
                        font-size: 12px;
                        font-weight: 400;
                      }
                    }
                  }
                }
              }
            }
          }
        }

        &.active {
          .step-footer {
            transition: 1s all;
            opacity: 1;
          }
        }

        .step-footer {
          opacity: 0;
          text-align: center;
          position: absolute;
          bottom: 37px;
          left: 50%;
          transform: translate(-50%, 0);
        }
      }

      &.active {
        height: 566px;
        overflow: visible;

        &.step-2 {
          //height: 570px;
          position: relative;
        }

        .step-title {
          &::after {
            transform: scaleY(1);
          }

          span {
            .show-on-active {
              width: 150px;
              opacity: 1;
            }

            .hide-on-active {
              width: 0;
              opacity: 0;
            }
          }
        }
      }

      &.animating {
        overflow: hidden;
      }
    }
  }

  .seperator {
    display: inline-block;
    vertical-align: top;
    width: 1px;
    height: 635px;
    margin: 10px 14px;
    background-color: #d7d7d7;
  }

  .right-side {
    display: inline-block;
    vertical-align: top;
    height: 652px;

    .guide {
      border-radius: 14px;
      background-color: #2f2f2f;
      width: 480px;
      height: 652px;
      position: relative;

      .carousel-control {
        .prev,
        .next {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          cursor: pointer;
          transition: opacity 0.2s ease;
          z-index: 5;

          &.disabled {
            opacity: 0;
            cursor: default;
            pointer-events: none;
          }
        }

        .prev {
          left: 13px;
        }

        .next {
          right: 13px;
        }

        .download {
          position: absolute;
          top: 30px;
          right: 20px;
          color: #ffffff;
          font-size: 13px;
          z-index: 5;

          .icon {
            margin-right: 5px;
            vertical-align: middle;
          }

          .text {
            vertical-align: middle;
          }
        }

        .carousel-navigation {
          position: absolute;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 5;

          button {
            width: 8px;
            height: 8px;
            background-color: #666666;
            overflow: hidden;
            margin: 0 4px;
            border-radius: 4px;
            transition: background-color 0.2s ease;

            &.active {
              background-color: #ffffff;
            }
          }
        }
      }

      .carousel-body {
        white-space: nowrap;
        overflow: hidden;

        .carousel-board {
          transition: transform 0.5s ease;
        }

        .carousel-content {
          display: inline-block;
          width: 480px;
          height: 655px;
          position: relative;

          .link {
            position: absolute;
            top: 29px;
            right: 18px;

            & a {
              display: flex;
              align-items: center;
              vertical-align: middle;
              gap: 5px;

              & span {
                color: #FFF;
                text-align: right;
                font-size: 13px;
                font-style: normal;
                font-weight: 500;
                line-height: 100%; /* 13px */
              }
            }
          }

          .c {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            .image {
              display: block;
              margin: 0 auto;
            }

            h5 {
              font-weight: 500;
              font-size: 15px;
              color: #ffffff;
              margin: 15px 50px;
            }

            p {
              font-size: 13px;
              line-height: 21px;
              margin: 15px 50px;
              color: #aaaaaa;

              & /deep/ em {
                color: #ffd100;
              }
            }

            &.c1 {
              .image {
                width: 400px;
                height: 280px;
                background-image: url(../../assets/img/add/img--guide-1-en.svg);
                margin: 0 auto 30px;

                &.ko {
                  background-image: url(../../assets/img/add/img--guide-1-ko.svg);
                }

                &.ja {
                  background-image: url(../../assets/img/add/img--guide-1-ja.svg);
                }
              }
            }

            &.c2 {
              .image {
                width: 238px;
                height: 166px;
                background-image: url(../../assets/img/add/img--guide-2-en.svg);
                margin: 40px auto;

                &.ko {
                  background-image: url(../../assets/img/add/img--guide-2-ko.svg);
                }
                &.ja {
                  background-image: url(../../assets/img/add/img--guide-2-ja.svg);
                }
              }
            }

            &.c3 {
              width: 100%;
              p {
                word-break: keep-all;
                white-space: break-spaces;
              }
            }

            &.c4 {
              .image {
                width: 230px;
                height: 220px;
                background-image: url(../../assets/img/add/img--guide-4.svg);
                margin: 15px auto 42px;
              }
            }

            &.c5 {
              .image {
                background-color: #fff;
                border-radius: 10px;
                width: 400px;
                height: 280px;
                margin: 32px;

                &.ko {
                  background-image: url(../../assets/img/add/img--guide-5-ko.svg);
                }
                &.ja {
                  background-image: url(../../assets/img/add/img--guide-5-ja.svg);
                }
                &.en {
                  background-image: url(../../assets/img/add/img--guide-5-en.svg);
                }

                & .item {
                  display: flex;

                  & .title {
                    .em1 {
                      background-color: #C5B7FF;
                    }
                    .em2 {
                      background-color: #C5B7FF;
                    }
                  }
                }
              }
            }

            &.c6 {
              .image {
                width: 400px;
                height: 280px;
                background-image: url(../../assets/img/add/img--guide-6-en.svg);
                margin: 0 auto 30px;

                &.ko {
                  background-image: url(../../assets/img/add/img--guide-6-ko.svg);
                }

                &.ja {
                  background-image: url(../../assets/img/add/img--guide-6-ja.svg);
                }
              }
              h5 {
                margin: 14px 10px;
                :deep(.highlight) {
                  margin-left: 10px;
                  color: #FCE515;
                  font-size: 12px;
                  font-weight: 600;
                }
              }

              p {
                margin: 14px 10px;
                word-break: keep-all;
                white-space: break-spaces;
              }
            }
          }
        }
      }
    }
  }

  .no-multi-domain {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;

    &.fade-leave-active,
    &.fade-enter-active {
      transition: opacity 0.5s ease;
      opacity: 1;
    }

    &.fade-enter,
    &.fade-leave-to {
      opacity: 0;
    }

    h3 {
      font-size: 20px;
      font-weight: 500;
      color: #444444;
      margin: 10px 0 20px 0;
    }

    p {
      font-size: 14px;
      line-height: 1.57;
      color: #666666;
      margin-bottom: 50px;
    }
  }

  .tracking-code-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 830px;
    border-radius: 34px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
    background-color: #ffffff;
  }

  .slide-fade-enter-active {
    transition: opacity 0.5s ease, transform 0.5s ease, top 0.5s ease;
    transition-delay: 0.2s;
    z-index: 1;
  }
  .slide-fade-leave-active {
    transition: opacity 0.3s ease, transform 0.3s ease, top 0.3s ease;
    z-index: 1;
  }

  .slide-fade-enter,
  .slide-fade-leave-to {
    top: calc(50% - 30px);
    opacity: 0;
    transform: translate(-50%, -50%);
  }
}
</style>
